import React, { ReactNode } from 'react';
import { PriceSection } from '../../PriceSection';
import { SizesSection } from '../../SizesSection';
import { ServicesSection } from '../../ServicesSection';
import { PriceSizeBlockWrapper } from './styled';
import { CurrentItemQuery } from '../../../../../graphql/graphql';

interface PriceSizeBlockProps {
  item: CurrentItemQuery['item'];
  prettyAreaWithUnits: string;
  prettyLandAreaWithUnits: string;
  priceCurrency: string;
  operationButton: ReactNode;
  onCreditCalcClick: React.Dispatch<React.SetStateAction<boolean>>;
  isAuthor: boolean;
  isExpired: boolean;
  userRelatedItemLoading: boolean;
}

export const PriceSizeBlock: React.FC<PriceSizeBlockProps> = ({
  item,
  prettyAreaWithUnits,
  priceCurrency,
  prettyLandAreaWithUnits,
  operationButton,
  onCreditCalcClick,
  isAuthor,
  isExpired,
  userRelatedItemLoading
}) => {
  return (
    <PriceSizeBlockWrapper $withoutBorder={isExpired && !isAuthor}>
      {operationButton}

      <PriceSection
        categoryId={item?.category?.id}
        priceTotal={item?.price?.total}
        pricePerAre={item?.price?.perAre}
        priceCurrency={priceCurrency}
        area={item?.area?.value}
        areaCurrency={item?.area?.units}
        isApartmentForSale={!item?.leased && item?.category?.hasFloor}
        isKapitalbankApplicable={item?.isKapitalbankApplicable}
        isAuthor={isAuthor}
        onCreditCalcClick={onCreditCalcClick}
        userRelatedItemLoading={userRelatedItemLoading}
      />
      <SizesSection
        area={prettyAreaWithUnits}
        floor={item?.floor}
        floors={item?.floors}
        rooms={item?.rooms}
        categoryName={item?.category?.name}
        landArea={prettyLandAreaWithUnits}
        buildingTypeName={item?.buildingTypeName}
      />

      <ServicesSection
        billOfSale={item?.hasBillOfSale}
        mortgage={item?.hasMortgage}
        repair={item?.hasRepair}
      />
    </PriceSizeBlockWrapper>
  );
};
